export const selectCartDropdown = (state) => state.dropdowns.cartDropdown;

export const selectLoginDropdown = (state) => state.dropdowns.loginDropdown;